export default __webpack_public_path__ + "static/media/1108.80c73d16.png";